import React, {useEffect, useState} from 'react';
import './App.css';
import StyleListViewer from "../../containers/style/StyleListViewer";
import ScrollContainer from 'react-indiana-drag-scroll'
import InputText from "../../containers/app/InputText";

const PartStyles = ({ setParamInfo }) => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        setLoaded(true);
    }, [])

    const styleList = React.createElement(StyleListViewer({setParamInfo}))

    return (

        <div className="breadcomb-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="breadcomb-list ov1">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="breadcomb-wp">
                                        <div className="breadcomb-ctn qr-j2">
                                            <h2>选择二维码样式</h2>
                                            <p>点击二维码选择样式，左右拖动可以查看更多样式。</p>
                                            <div className="qr-pd2">
                                                <ScrollContainer
                                                    className="Qr-s"
                                                    hideScrollbars={false}
                                                    horizontal={true}
                                                    vertical={false}
                                                    style={{visibility: loaded ? "visible" :"hidden"}}>
                                                    {styleList}
                                                </ScrollContainer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PartStyles;
